<template>
  <v-app>
    <library-list ref="book-list"></library-list>
  </v-app>
</template>

<script>
import LibraryList from "./List";

export default {
  name: "Index",
  components: {LibraryList},
  data() {
    return {
      tab: null,
      new_book_dialog: false,
    }
  }, methods: {
    closeNewBookDialog() {
      this.new_book_dialog = false
      this.getBooks()
    },
    addNewBook() {
      this.new_book_dialog = true
    },
    refreshList() {
      this.$refs['book-list'].getBooks();
      this.$refs['issued-list'].getIssuedBooks()
      this.$refs['issued-history'].getIssuedBooks()
    }

  }
}
</script>

<style scoped>

</style>